import React from 'react';
import styled from 'styled-components';
import FileUpload from './file-upload';
import theme from '@styles/theme';
const { colors } = theme;

const JobPostForm = ({
  errors,
  handleBlur,
  handleChange,
  handleSubmit,
  touched,
  values,
  handleCloseModal,
  setFiles,
  setErrors,
}) => {
  return (
    <div>
      <StyledForm onSubmit={handleSubmit} autoComplete="off">
        <StyledInput
          type="text"
          id="first-name"
          name="firstName"
          placeholder="First Name"
          value={values.firstName}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <StyledError>{touched.firstName && errors.firstName}</StyledError>
        <StyledInput
          type="text"
          id="last-name"
          name="lastName"
          placeholder="Last Name"
          value={values.lastName}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <StyledError>{touched.lastName && errors.lastName}</StyledError>
        <StyledInput
          type="text"
          id="email"
          name="email"
          placeholder="Email"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <StyledError>{touched.email && errors.email}</StyledError>
        <StyledInput
          type="text"
          id="mobile-phone"
          name="mobilePhone"
          placeholder="Mobile Number"
          value={values.mobilePhone}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <StyledError>{touched.mobilePhone && errors.mobilePhone}</StyledError>
        <StyledUploadArea>
          <FileUpload setFiles={setFiles} errors={errors} setErrors={setErrors} />
          <StyledError>{errors.resume}</StyledError>
        </StyledUploadArea>
        <StyledButtonWrapp>
          <CancelButton onClick={handleCloseModal}>Cancel</CancelButton>
          <ApplyButton type="submit">Apply</ApplyButton>
        </StyledButtonWrapp>
      </StyledForm>
    </div>
  );
};

export default JobPostForm;

const StyledInput = styled.input`
  display: block;
  width: 100%;
  margin-bottom: 4px;
  margin-top: 32px;
  outline: none;
  font-size: 24px;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
`;

const StyledError = styled.div`
  color: red;
  font-size: 16px;
  margin-bottom: 56px;
`;

const StyledForm = styled.form`
  padding: 24px 48px;
`;

const StyledUploadArea = styled.div`
  width: 100%;
  height: 100px;
  background-color: ${colors.lightGray};
  margin-bottom: 64px;
  position: relative;
`;

const StyledButtonWrapp = styled.div`
  display: flex;
`;

const ApplyButton = styled.button`
  flex: 1;
  background-color: ${colors.lightPurple};
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  color: ${colors.white};
  margin-left: 8px;
  border: 0px;
  cursor: pointer;
`;

const CancelButton = styled.div`
  padding-top: 16px;
  padding-bottom: 16px;
  flex: 1;
  cursor: pointer;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-right: 8px;
  color: ${colors.black};
  background-color: ${colors.lightGray};
`;
